<template>
    
    <div id="wrapper">
    
        <site-header></site-header>
    
        <main id="main">
            <transition name="fade">
                <router-view></router-view>
            </transition>
        </main>
    
        <site-footer></site-footer>
    
    </div>

</template>

<style lang="scss">
.box {
    background: #fff;
    padding: 20px;
    border-radius: 4px;
    box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.05);
    border: 1px solid #ddd;
}
.flex-wrapper {
    display: flex;
    align-items: center;

    &:not(:last-of-type) {
        margin-bottom: 20px;
    }

    .icon {
        margin-right: 20px;
        font-size: 2em;
    }

    .text {

    }
}
body, body * {
    line-height: 1.5;
}
</style>

<script>
    import Header from './header'
    import Footer from './footer'
    export default {
        components: {
            'site-header': Header,
            'site-footer': Footer
        }
    }
</script>



// WEBPACK FOOTER //
// layout.vue?71ea15e0